import { createAsyncThunk } from "@reduxjs/toolkit";
import { getProfitLossBalanceApi } from "../../../apiservice/dashboard";

export const fetchProfitLoss = createAsyncThunk(
  "profitLoss/fetch",
  async ({ filters }, { rejectWithValue }) => {
    try {
      const payload = { selectedFilterType: filters?.filterType };
      if (filters?.filterType === "Date Wise") {
        payload.fromDate = filters?.fromDate;
        payload.toDate = filters?.toDate;
      }

      const res = await getProfitLossBalanceApi(payload);
      const raw = res?.data?.data ?? res?.data ?? {};

      // Normalize fields (covers multiple naming conventions)
      const data = {
        // left / debit side
        purchaseBalance: raw.purchaseBalance ?? raw.purchase_balance ?? 0,
        productTransferReceivedBalance:
          raw.productTransferReceivedBalance ??
          raw.product_transfer_received_balance ??
          0,
        serviceExpenseBalance:
          raw.serviceExpenseBalance ?? raw.service_expense_balance ?? 0,
        salesReturnBalance: raw.salesReturnBalance ?? raw.sales_return_balance ?? 0,
        directExpenseBalance:
          raw.directExpenseBalance ?? raw.direct_expense_balance ?? 0,

        // product wise details
        itemCostingAmount: raw.itemCostingAmount ?? raw.item_costing_amount ?? 0,
        itemSoldAmount: raw.itemSoldAmount ?? raw.item_sold_amount ?? 0,
        item_profit_reversal: raw.item_profit_reversal ?? raw.item_profit_reversal ?? 0,
        item_replace_loss: raw.item_replace_loss ?? raw.item_replace_loss ?? 0,
        item_profit_replace: raw.item_profit_replace ?? raw.item_profit_replace ?? 0,
        itemProfitLoss: raw.itemProfitLoss ?? raw.item_profit_loss ?? 0,

        // totals
        debitAmount: raw.debitAmount ?? raw.debit_amount ?? 0,
        debitTotal: raw.debitTotal ?? raw.debit_total ?? 0,

        // right / credit side
        purchaseReturnBalance:
          raw.purchaseReturnBalance ?? raw.purchase_return_balance ?? 0,
        salesBalance: raw.salesBalance ?? raw.sales_balance ?? 0,
        productTransferBalance:
          raw.productTransferBalance ?? raw.product_transfer_balance ?? 0,
        serviceBalance: raw.serviceBalance ?? raw.service_balance ?? 0,
        serviceReturnBalance: raw.serviceReturnBalance ?? 0,
        directIncomeBalance:
          raw.directIncomeBalance ?? raw.direct_income_balance ?? 0,
        currentInventoryBalance:
          raw.currentInventoryBalance ?? raw.current_inventory_balance ?? 0,
        adjustmentBalance: raw.adjustmentBalance ?? raw.adjustment_balance ?? 0,

        // credit totals
        creditAmount: raw.creditAmount ?? raw.credit_amount ?? 0,
        creditTotal: raw.creditTotal ?? raw.credit_total ?? 0,

        // previous gross / net and indirects
        netProfit: raw.netProfit ?? raw.previousGrossProfit ?? raw.net_profit ?? 0,
        indirectIncomeBalance:
          raw.indirectIncomeBalance ?? raw.indirect_income_balance ?? 0,
        indirectExpenseBalance:
          raw.indirectExpenseBalance ?? raw.indirect_expense_balance ?? 0,
      };

      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
